export default __webpack_public_path__ + "static/media/Offre_Clarte.6deb68b9.jpg";